export const ANIMATION_CONFIG = { mass: 1, tension: 120, friction: 14 };
export const MOBILE_PAGE_TOP_PADDING = 96;
export const TABLET_PAGE_TOP_PADDING = 186;
export const CHAT_ITEM_ANIMATION_CONFIG = {
  from: { opacity: 0, transform: 'translate3d(0,40px,0)' },
  enter: { opacity: 1, transform: 'translate3d(0,0px,0)' },
  leave: { opacity: 0 },
  config: ((_: any, state: string) =>
    state === 'leave' ? { duration: 0 } : ANIMATION_CONFIG) as never,
};
